<template>
    <div>
        <h1 style="font-size: 24px; color: black;">APP版本管理</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="cdn" size="small" label-width="120px">
                <el-form-item label="cdn刷新：">
                    <el-input style="width: 300px" placeholder="刷新url" v-model="cdn.url"></el-input>
                </el-form-item>
                <el-form-item label=" taskId：">
                    <el-input style="width: 300px" placeholder="taskId" v-model="cdn.taskId"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button class="sub-sub" type="primary" @click="cdnFresh">刷新</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button class="sub-sub" type="primary" @click="cdnQuery">查询</el-button>
                </el-form-item>
            </el-form>
            <el-form :inline="true" :model="queryData" size="small" label-width="120px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="datetimerange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item >
                    <el-button class="sub-sub" type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button class="sub-sub" type="primary" @click="showDetails('新增版本')">新增</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button class="sub-sub" type="primary" @click="jumpVersionCopy">版本列表管理</el-button>
                </el-form-item>
                <el-form-item >
                    <el-button class="sub-sub" type="danger" @click="showRule">版本更新规则(更新必看)</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="list"
                      style="width: 100%"
                      border>
                <el-table-column label="日期" align="center">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.dt, "yyyy-MM-DD HH:mm:ss") }}
                    </template>
                </el-table-column>
                <el-table-column label="关联渠道" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{
                            scope.row.subChannel.length === subChannels.length ? '全部' : scope.row.subChannelNames.toString()
                        }}
                    </template>
                </el-table-column>
                <el-table-column label="版本号" prop="versionCode" align="center"></el-table-column>
                <el-table-column label="版本名" prop="versionName" align="center"></el-table-column>
                <el-table-column label="更新标识" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.forcedUpdate===true ">强制更新</div>
                        <div v-if="scope.row.forcedUpdate===false">非强制更新</div>
                    </template>
                </el-table-column>
                <el-table-column label="更新包型" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.blackOrWhite===true ">白包</div>
                        <div v-if="scope.row.blackOrWhite===false">黑包</div>
                    </template>
                </el-table-column>
                <el-table-column label="更新文案" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click.native.stop="checkDesc(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain type="primary" size="mini" @click="showDetails('编辑版本',scope.row)">编辑</el-button>
                        <el-button plain type="danger" size="mini" @click="deleteVersion(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="versionEditForm" label-width="150px">
                    <el-form-item label="渠道选择:">
                        <el-cascader :disabled="dialogTitle==='编辑版本'" style="width: 300px"
                                     v-model="versionEditForm.subChannel" :options="channelList" :props="optionProps"
                                     clearable collapse-tags placeholder="请选择">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="版本号:">
                        <el-input :disabled="dialogTitle==='编辑版本'" style="width: 300px" type="text"
                                  v-model="versionEditForm.versionCode"></el-input>
                    </el-form-item>
                    <el-form-item label="版本名:">
                        <el-input :disabled="dialogTitle==='编辑版本'" style="width: 300px" type="text"
                                  v-model="versionEditForm.versionName"></el-input>
                    </el-form-item>
                    <el-form-item label="更新地址:">
                        <el-input style="width: 300px" placeholder="请输入内容" v-model="versionEditForm.updateUrl">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="更新标识:">
                        <el-radio-group v-model="versionEditForm.forcedUpdate">
                            <el-radio :label="1">强制更新</el-radio>
                            <el-radio :label="0">非强制更新</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="最小兼容版本号(≤):">
                        <el-input-number v-model="versionEditForm.miniVersionCode" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="最大兼容版本号(≤):">
                        <el-input-number v-model="versionEditForm.maxVersionCode" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="更新包型:">
                        <el-radio-group v-model="versionEditForm.blackOrWhite">
                            <el-radio :label="1">白包</el-radio>
                            <el-radio :label="0">黑包</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="更新文案:">
                        <el-input style="width: 300px" type="textarea" v-model="versionEditForm.description"></el-input>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirm">确 定</el-button>
                        <el-button type="info" @click="cancel">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
            <el-dialog title="版本文案" center :visible.sync="dialogDescVisible" width="50%" :data="desc">
                <h1>{{ desc }}</h1>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {cdnFresh, cdnQuery, channelList, saveVersion, searchVersion, deleteVersion} from "@/http/api";
import utils from '@/utils'

export default {
    inject: ['reload'],
    name: "VersionList",
    data() {
        return {
            dialogDescVisible: false,
            dialogVisible: false,
            dialogTitle: '',
            desc: [],
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            queryData: {
                timeDate: '',
            },
            queryTrueData: {
                timeDate: '',
                startTime: '',
                endTime: '',
                order: 'desc',
                prop: 'dt'
            },
            list: [],
            versionEditForm: {},
            channelList: [],
            //子渠道集合
            subChannelList: [],
            //子渠道号集合
            subChannels: [],
            //子渠道名称集合
            subChannelNames: [],
            cdn: {
                url: 'https://cdn.gameley.cn/ftp/',
                taskId: ''
            }
        }
    },
    methods: {
        formatDate: function (column, format) {
            return utils.DateUtil.formatDate(column, format)
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.search();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.search();
        },
        showDetails(title, row) {
            this.versionEditForm = {
                "blackOrWhite": 0,
                "description": "",
                "forcedUpdate": 0,
                "id": 0,
                "subChannel": [],
                "updateUrl": "",
                "versionCode": "",
                "versionName": "",
                "miniVersionCode": 0,
                "maxVersionCode": 0,
            };

            this.dialogTitle = title;
            this.dialogVisible = true;

            if (row) {
                this.versionEditForm = {
                    "blackOrWhite": row.blackOrWhite === true ? 1 : 0,
                    "description": row.description,
                    "forcedUpdate": row.forcedUpdate === true ? 1 : 0,
                    "id": row.id,
                    "subChannel": row.subChannel,
                    "updateUrl": row.updateUrl,
                    "versionCode": row.versionCode,
                    "versionName": row.versionName,
                    "miniVersionCode": row.miniVersionCode,
                    "maxVersionCode": row.maxVersionCode,
                };
            }
        },
        search() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryTrueData.startTime = this.queryData.timeDate[0];
            this.queryTrueData.endTime = this.queryData.timeDate[1];
            this.queryTrueData.size = this.page.size;
            this.queryTrueData.page = this.page.page;
            searchVersion(this.queryTrueData).then(resp => {
                let _this = this;
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements;
                this.list.forEach(function (version) {
                    _this.$set(version, 'subChannel', version.subChannel.split(','));
                    _this.subChannelList.forEach(function (sub) {
                        version.subChannel.forEach(function (subChannel) {
                            if (sub.subChannel === subChannel) {
                                _this.subChannelNames.push(sub.name);
                            }
                        })
                    });
                    _this.$set(version, 'subChannelNames', _this.subChannelNames);
                    _this.subChannelNames = [];
                })
            });
        },
        confirm() {
            saveVersion(this.versionEditForm).then(resp => {
                if (resp.data.status === 0) {
                    this.dialogVisible = false;
                    this.reload();
                }
            })
        },
        deleteVersion(id){
            this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteVersion(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.search()
                    }
                })
            }).catch(() => {
            })
        },
        jumpVersionCopy() {
            this.$router.push({path: '/versionCopy'});
        },
        showRule(){
            this.$message({
                showClose: true,
                center: true,
                dangerouslyUseHTMLString: true,
                message: '<h4>(1)最大最小版本号必填；</h4></br>' +
                    '<h5>(2)版本号介于最大最小版本号之间，走配置表内容</h5></br>' +
                    '<h5>(3)其余情况一律不更新，不弹窗提示</h5></br>',
                type: 'warning',
                duration: 0,
                offset:180
            });
        },
        cancel() {
            this.dialogVisible = false;
        },
        checkDesc(_row) {
            this.dialogDescVisible = true;
            this.desc = _row.description
        },
        cdnFresh() {
            cdnFresh(this.cdn.url).then(resp => {
                const result = resp.data.info;
                if (resp.data.status === 0) {
                    this.cdn.taskId = result;
                    alert("刷新成功，taskId=" + result);
                } else {
                    alert(result);
                }
            })
        },
        cdnQuery() {
            cdnQuery(this.cdn.taskId).then(resp => {
                alert(resp.data.info);
            })
        }
    },
    created() {
        this.queryTrueData.timeDate = [utils.TodayUtil.getYesterday(), utils.TodayUtil.getNow()];
        channelList().then(resp => {
            let _this = this;
            this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.channelList.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
                channel.children.forEach(function (sub) {
                    _this.subChannelList.push(sub);
                    _this.subChannels.push(sub.subChannel);
                })
            });
            this.search();
        });
    }
}
</script>

<style scoped>
</style>